import { FormControl, OutlinedInput } from "@mui/material";
import { CustomTypography } from "../CustomTypography/CustomTypography";
import useStyles from "./styles";
import { ChangeEventHandler } from "react";

type Props = {
  placeholder?: string;
  label?: string;
  marginBottom?: string | number;
  rows?: string | number;
  value?: unknown;
  name?: string;
  onChange?:
    | ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
};

export const CustomTextInput: React.FC<Props> = ({
  placeholder,
  label,
  marginBottom,
  rows,
  value,
  name,
  onChange,
}) => {
  const classes = useStyles({ marginBottom, rows });

  return (
    <div className={classes.container}>
      {label && (
        <div className={classes.containerLabel}>
          <CustomTypography
            text={label}
            variant={"link"}
            textDecoration={"none"}
          />
        </div>
      )}
      <FormControl className={classes.formControl} variant="outlined">
        <OutlinedInput
          name={name}
          value={value}
          onChange={onChange}
          fullWidth
          placeholder={placeholder}
          multiline={rows ? true : false}
          rows={rows}
        />
      </FormControl>
    </div>
  );
};
